import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996ZM12.4998 7.49996C12.4998 8.88067 11.3805 9.99996 9.99984 9.99996C8.61912 9.99996 7.49984 8.88067 7.49984 7.49996C7.49984 6.11925 8.61912 4.99996 9.99984 4.99996C11.3805 4.99996 12.4998 6.11925 12.4998 7.49996ZM9.99982 17.0833C11.4865 17.0833 12.8663 16.6253 14.0056 15.8426C14.5088 15.497 14.7239 14.8385 14.4313 14.3027C13.8248 13.1918 12.575 12.5 9.99978 12.5C7.42458 12.5 6.17481 13.1918 5.56829 14.3026C5.27571 14.8384 5.49075 15.4969 5.99397 15.8426C7.13332 16.6252 8.51308 17.0833 9.99982 17.0833Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }